import React, { useEffect, useState } from 'react';
import { Stack } from 'react-bootstrap';
import MeteorologyWeatherImageDisplay from 'components/Meteorology/Weather/SeasonalForecast/ImageDisplay';
import PeriodSlider from 'components/Meteorology/Weather/SeasonalForecast/PeriodSlider';
import SeasonalForecastToolbar from 'components/Meteorology/Weather/SeasonalForecast/Toolbar';
import InstructionsModal from 'components/Meteorology/Weather/SeasonalForecast/InstructionsModal';
import SeasonalForecastMobile from 'components/Meteorology/Weather/SeasonalForecast/Mobile';
import { store } from 'redux/store';
import { setCurrentTab } from 'redux/reducers/weatherLayoutReducer';
import { useClosure } from 'utils/hooks';
import useIsMobile from 'utils/hooks/useIsMobile';

export default function SeasonalForecast() {
  const [showInstructions, setShowInstructions] = useState(false);
  const isMobile = useIsMobile();
  const closeInstructions = useClosure(setShowInstructions, false);
  const openInstructions = useClosure(setShowInstructions, true);

  useEffect(() => {
    store.dispatch(setCurrentTab('seasonal-forecast'));
  }, []);

  if (isMobile) {
    return <SeasonalForecastMobile />;
  }

  return (
    <div>
      <InstructionsModal
        show={showInstructions}
        onHide={closeInstructions}
      />
      <Stack className="m-4">
        <div className="d-md-flex justify-content-between align-items-center">
          <div className="flex-grow-1">
            <PeriodSlider />
          </div>
          <div>
            <SeasonalForecastToolbar
              onInstructionsClick={openInstructions}
            />
          </div>
        </div>
        <MeteorologyWeatherImageDisplay />
      </Stack>
    </div>
  );
}
